import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Group, { GroupAddon } from '@lightspeed/cirrus-group';
import { Button } from '@lightspeed/flame/Button';
import { IconSmallChevronLeft } from '@lightspeed/flame/Icon/SmallChevronLeft';
import { IconSmallChevronRight } from '@lightspeed/flame/Icon/SmallChevronRight';

const baseClass = 'cr-pager';

const PREVIOUS_PAGE = 'PREVIOUS_PAGE';
const NEXT_PAGE = 'NEXT_PAGE';

export class PagerComponent extends Component {
  static get defaultProps() {
    return {
      reversed: false,
      currentPage: 1,
      totalPages: 1,
      showPages: false,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      currentPage: this.props.currentPage,
    };

    this.handlePrevious = this.handlePrevious.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.resultsText = 'results';
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentPage !== this.state.currentPage) {
      this.setState({ currentPage: nextProps.currentPage });
    }
  }

  isControlDisabled(control) {
    let controlDisabled = !!(this.props.totalPages <= 1 || !this.props.onPageChange);

    if (control === PREVIOUS_PAGE) {
      controlDisabled = this.state.currentPage === 1;
    } else if (control === NEXT_PAGE) {
      controlDisabled = this.state.currentPage >= this.props.totalPages;
    }

    return controlDisabled;
  }

  handlePrevious() {
    this.setState(prevState => {
      const { currentPage } = prevState;
      const { onPageChange } = this.props;
      const previousPage = currentPage > 1 ? currentPage - 1 : 1;
      onPageChange(previousPage);
      return { currentPage: previousPage };
    });
  }

  handleNext() {
    this.setState(prevState => {
      const { totalPages, onPageChange } = this.props;
      const { currentPage } = prevState;
      const nextPage = currentPage < totalPages ? currentPage + 1 : totalPages;
      onPageChange(nextPage);
      return { currentPage: nextPage };
    });
  }

  renderResults() {
    const { currentPage } = this.state;
    const { perPage, total, totalPages } = this.props;

    const lowerIndex = (currentPage - 1) * perPage + 1;
    const higherIndex = currentPage !== totalPages ? currentPage * perPage : total;

    return total > 0 ? (
      <span key="unique-for-localize">
        <span className="cr-bold">
          <var data-test="pager-lower-index">{lowerIndex}</var> -{' '}
          <var data-test="pager-higher-index">{higherIndex}</var>
        </span>{' '}
        of <var data-test="pager-total">{total}</var> {this.resultsText}
      </span>
    ) : null;
  }

  render() {
    const { reversed, className } = this.props;
    const classNames = cn(baseClass, className);
    const results = this.renderResults();

    return (
      <Group className={classNames} reversed={reversed}>
        {results && <div className="cr-pager__results">{results}</div>}
        <Group noSpacing>
          <Button
            data-test="pager-previous-button"
            disabled={this.isControlDisabled(PREVIOUS_PAGE)}
            onClick={this.handlePrevious}
          >
            <IconSmallChevronLeft />
          </Button>
          {this.props.showPages && (
            <GroupAddon style={{ display: 'none' }}>
              <span>
                {this.state.currentPage} of {this.props.totalPages}
              </span>
            </GroupAddon>
          )}
          <Button
            data-test="pager-next-button"
            disabled={this.isControlDisabled(NEXT_PAGE)}
            onClick={this.handleNext}
          >
            <IconSmallChevronRight />
          </Button>
        </Group>
      </Group>
    );
  }
}

PagerComponent.propTypes = {
  reversed: PropTypes.bool,
  onPageChange: PropTypes.func,
  showPages: PropTypes.bool,
  currentPage: PropTypes.number,
  perPage: PropTypes.number,
  total: PropTypes.number,
  totalPages: PropTypes.number,
  className: PropTypes.string,
};

export default PagerComponent;
